// new accordian style
$(document).ready(function() {
  $(".accordian-panel > .accordian-heading").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".accordian-content")
        .slideUp(200);
      $(".accordian-panel > .accordian-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".accordian-panel > .accordian-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".accordian-panel > .accordian-heading").removeClass("active");
      $(this).addClass("active");
      $(".accordian-content").slideUp(200);
      $(this)
        .siblings(".accordian-content")
        .slideDown(200);
    }
  });
});

$(document).ready(function() {
  jQuery('.slickslider').slick({
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    arrows: true,
    speed: 500,
    slide: 'div',
    cssEase: 'linear',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
});

/* Envision - Geolocation Modal */

function getGeolocation() {
  return fetch("https://ipapi.co/json/").then(response => response.json());
}

$(document).ready(function() {
  const geolocationModal = $('[data-remodal-id="geolocationModal"]');
  getGeolocation().then(data => {
    const hostname = window.location.hostname;
    const countryWrappers = geolocationModal.find(".geolocation-modal__country");
    const countryAdjectiveWrappers = geolocationModal.find(".geolocation-modal__country-adjective");
    const countryCodeWrappers = geolocationModal.find(".geolocation-modal__country-code");
    const domainWrappers = geolocationModal.find(".geolocation-modal__domain")
    const continentCode = data.continent_code;
    const countryCode = data.country_code;
    const country = data.country_name;
    if (continentCode === "EU" && hostname !== "eu.gelblaster.com") {
      const initGeolocationModal = geolocationModal.remodal();
      countryWrappers.text(country);
      countryAdjectiveWrappers.text("European");
      countryCodeWrappers.text(continentCode);
      domainWrappers.text("eu.gelblaster.com");
      domainWrappers.attr("href", "https://eu.gelblaster.com");
      initGeolocationModal.open();
      $(document).on('confirmation', '.remodal', function () {
        window.location.href = domainWrappers.attr("href");
      });
    } else if (countryCode === "ZA" && hostname !== "thegelblaster.co.za") {
      const initGeolocationModal = geolocationModal.remodal();
      countryWrappers.text(country);
      countryAdjectiveWrappers.text("South African");
      countryCodeWrappers.text(countryCode);
      domainWrappers.text("thegelblaster.co.za");
      domainWrappers.attr("href", "https://thegelblaster.co.za");
      initGeolocationModal.open();
      $(document).on('confirmation', '.remodal', function () {
        window.location.href = domainWrappers.attr("href");
      });
    } else if (countryCode === "US" && hostname !== "gelblaster.com") {
      const initGeolocationModal = geolocationModal.remodal();
      countryWrappers.text(country);
      countryAdjectiveWrappers.text(countryCode);
      countryCodeWrappers.text(countryCode);
      domainWrappers.text("gelblaster.com");
      domainWrappers.attr("href", "https://gelblaster.com");
      initGeolocationModal.open();
      $(document).on('confirmation', '.remodal', function () {
        window.location.href = domainWrappers.attr("href");
      });
    }
  });
});
